
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { getGameResultCount, getLicenseTeamLogs } from "../../services/gameLog.services.js";
import GameListCard from './components/GameListCard'; 
import mainImg from '../assets/dashboard.png';
import './gamelog.css'; 

const GameLog = (props) => {
  const [loading, setLoading] = useState(false);
  const [countLoading, setCountLoading] = useState(false);
  const [data, setData] = useState(null);
  const [countData, setCountData] = useState(null);
  const [error, setError] = useState(null);

  const user = useSelector((state) => state.auth.user);
  const operatorTeam = useSelector((state) => state.team.selectedTeam);
  const history = useHistory();

  const navigateToGameLogDetails = (logId) => {
    history.push(`/gamelog/${logId}`);
  };

  const handleGetAllGames = async () => {
    try {
      setLoading(true);
      const response = await getLicenseTeamLogs(operatorTeam?.teamId._id, user?.token);
      setData(response.data);
    } catch (error) {
      console.log("ERROR in getLicenseTeamLogs", error.message);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleGetGameResultCount = async () => {
    try {
      setCountLoading(true);
      const response = await getGameResultCount(operatorTeam?.teamId._id, user?.token);
      setCountData(response.data);
    } catch (error) {
      console.log("ERROR in getGameResultCount", error.message);
      setError(true);
    } finally {
      setCountLoading(false);
    }
  };

  const FetchScreenData = async () => {
    await handleGetGameResultCount();
    await handleGetAllGames();
  };

  useEffect(() => {
    FetchScreenData();
  }, [operatorTeam?.teamId._id, user?.token]);

  const goBack = () => {
    history.goBack();
  };


  return (
    <div className="mainBg">
      
      <div className="backBtn">
        <button
          className="actionButtonBack"
          onClick={goBack}
        >
          &larr;
        </button>
      </div>
      <h1 className="mainHeading">GAME SCHEDULE & RESULTS</h1>

      <div className='imageBoxMain'>
          <img src={mainImg} className="headerImage" alt="Dashboard Header" />
      </div>
      <p className='teamNameMain'>{operatorTeam?.teamId?.teamName}</p>
      
      {countLoading ? (
        <p style={{ fontWeight: '900', color: 'white' }}>Loading...</p>
      ) : (
        countData && (
          <div className="countView">
            <div className="countView2">
              <p className="redTxt">CONFERENCE </p>
              <p className="redTxt">{countData?.conference?.won} -</p>
              <p className="redTxt">{countData?.conference?.lost} -</p>
              <p className="redTxt">{countData?.conference?.tied}</p>
            </div>
            <div className="countView2">
              <p className="redTxt">OVERALL </p>
              <p className="redTxt">{countData?.overall?.won} -</p>
              <p className="redTxt">{countData?.overall?.lost} -</p>
              <p className="redTxt">{countData?.overall?.tied}</p>
            </div>
          </div>
        )
      )}

      <div style={{margin: '0 25px 0 25px'}}>
        {loading ? (
          <p style={{ fontWeight: '900', color: 'white' }}>Loading...</p>
        ) : data && data.length > 0 ? (
          data.slice(0).reverse().map((v, i) => (
            <div className="featuredContain">
            <GameListCard
              key={v._id}
              playGame={props.playGame}
              navigation={history}
              data={v}
              handleGetAllGames={FetchScreenData}
            />
            </div>
          ))
        ) : (
          <p className="notFoundTxt">No Game Log Found!</p>
        )}
      </div>
    </div>
  );
};

export default GameLog;
